import { takeLatest, put } from 'redux-saga/effects';
import { appNotify, refreshModelTax, setIsRefreshingModelTax } from 'store/actions'
import { postWithTokenV2 } from 'api/network';

export function* refreshModelTaxSaga() {
  yield takeLatest(refreshModelTax, function* ({ payload }) {
    try {
      yield put(setIsRefreshingModelTax(true));

      const { txnOppId, bidPrice, callback } = payload;
      
      const {transactionOpportunityId, taxProformaInputs} = yield postWithTokenV2('/api/underwrite/prop/refreshModelTax', {transactionOpportunityId: txnOppId, bidPrice: bidPrice});

      yield put(setIsRefreshingModelTax(false));

      yield callback(transactionOpportunityId, taxProformaInputs); 

      yield put(appNotify('Refresh Model Tax Success', 'success', { autoHideDuration: 1500 }));
    } catch (error) {
      yield put(appNotify(error.message, 'error'));
      yield put(setIsRefreshingModelTax(false));
    }
  });
}